<template>
	<div class="hp-events" v-if="items?.length">
		<div class="wider-wrapper">
			<BaseCmsLabel code="events_title" tag="h2" />
			<div class="hp-events-flex">
				<template v-for="item in items" :key="item.id">
					<NuxtLink :to="item.url_without_domain" class="hp-event">
						<figure class="hp-event-img">
							<BaseUiImage :data="item.main_image_thumbs?.['width335-height210-crop1']" default="/images/no-image-335-2.jpg" loading="lazy" />
						</figure>
						<div class="hp-event-cnt">
							<div class="hp-event-category" v-if="item.category_title">{{item.category_title}}</div>
							<div class="hp-event-title" v-if="item.title">{{item.title}}</div>
							<div class="hp-event-date">
								<ClientOnly>
									<BaseUtilsFormatDate :date="item.date" format="DD.MM.YYYY." v-if="item.date" />
									<template v-if="item.date_end"> do <BaseUtilsFormatDate :date="item.date_end" format="DD.MM.YYYY." /></template>
								</ClientOnly>
							</div>
						</div>
					</NuxtLink>
				</template>
			</div>
			<div class="hp-events-btn-cnt">
				<NuxtLink to="/dogadanja/" class="btn btn-primary"><span><BaseCmsLabel code="events_btn" /></span></NuxtLink>
			</div>
		</div>
	</div>
</template>

<script setup>
	const { gtmTrack } = useGtm();
	const props = defineProps(['items']);

	onMounted(() => {
		gtmTrack('impressionsPromo', {
			ecommerce: {
				promoView: {
					promotions: props.items.map((item, index) => ({
						id: item.id ? item.id : '',
						name: item.title ? item.title : '',
						creative: 'banner' + (index + 1),
						position: 'slot' + (index + 1)
					}))
				} 
			}
		}, { custom: true });
	});
</script>
